module.exports = __webpack_public_path__ + "img/tab-brading.db1b6cfc.png";